import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';
import enLocales from './public/locales/en/common.json';
import deLocales from './public/locales/de/common.json';
export const resources = {
    en: { common: enLocales },
    de: { common: deLocales },
};
const ns = ['common'];
const supportedLngs = ['en', 'de'];
const i18n = i18next.createInstance();
i18n.use(initReactI18next).init({
    lng: i18n.language || 'de',
    fallbackLng: 'en',
    defaultNS: 'common',
    ns,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    supportedLngs,
    resources,
});
export default i18n;
